export enum ImmunizationValue {
  EXEMPT = 'Exempt',
}
